import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: theme => ({
    borderWidth: 1,
    borderColor: theme.colors.borderColorThree,
    borderRaduis: 2,
    width: '100%',
    paddingVertical: 16,
    paddingHorizontal: 19,
    marginBottom: 20,
  }),
  mainContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    height: 33,
    width: 33,
    resizeMode: 'contain',
  },
  titleAndSubtitleContainer: {
    marginLeft: 17,
    flex: 1,
  },
  title: theme => ({
    fontSize: 18,
    lineHeight: 25,
    color: theme.colors.textColor,
  }),
  subtitle: theme => ({
    fontSize: 16,
    lineHeight: 23,
    color: theme.colors.textColor,
  }),
  rightIconContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    shadowColor: theme.colors.shadowColor,
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    elevation: 7,
  }),
  image: {
    height: 48,
    width: 92,
  },
  separator: theme => ({
    width: '100%',
    borderColor: theme.colors.borderColorThree,
    borderWidth: 0.5,
    marginVertical: 16,
  }),
  descriptionAndButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  description: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: 15,
    width: '63%',
    lineHeight: 17,
    fontFamily: Fonts.type.VFFont,
  }),
  button: {
    width: 92,
    height: 33,
  },
  buttonText: {
    fontSize: 17,
    lineHeight: 21,
    fontWeight: 'bold',
  },
});
